import styled from '@emotion/styled';

import { Flex } from '../../../Common/Flex';
import { P } from '../../../Common/Typography';



export const VideoContentWrapper = styled(Flex)`
@media screen and (max-width: 880px) {
  flex-direction: column;
}
`

export const MovieCard = styled.div`
  position: relative;
  flex: 3;
  display: block;
  width: 95%;
  max-width: 650px;
  aspect-ratio: 16/9;
  overflow: hidden;
  border-radius: 10px;
  transition: all 0.4s;
  &:hover{
    transform: scale(1.02);
    transition: all 0.4s;
    cursor: pointer;
  }
`;

export const VideoDescriptionWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px 0 0 16px;
  flex: 8;
`;

export const VideoDescription = styled(P)`
  @media screen and (max-width: 400px) {
    font-size: 13px;
  }
`;

export const BlurBack = styled.div<{ bgImg: string }>`
  position: absolute;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  top: 0;
  z-index: 1;
  height: 100%; 
  right: 0;
  border-radius: 11px;
  background-image: ${({ bgImg })=> `url(${bgImg})`};
`;